export function parseTime(timeStr: string): number | null {
  if (!timeStr) return null;
  const str = timeStr.trim().toUpperCase();
  
  // E.g. "T#5S", "T#1M30S"
  let cleanStr = str;
  if (cleanStr.startsWith('T#')) {
    cleanStr = cleanStr.substring(2);
  } else if (cleanStr.startsWith('TIME#')) {
    cleanStr = cleanStr.substring(5);
  }

  // Fallback to strict milliseconds if it's just a number
  if (/^\d+(\.\d+)?$/.test(cleanStr)) {
    // If user typed "100" we assume ms for safety, but typically users write "100ms"
    return Math.floor(parseFloat(cleanStr));
  }

  // Regex to match sequences like 1h, 2m, 3s, 500ms
  // It handles floats like 2.5s -> 2500ms
  const regex = /(\d+(?:\.\d+)?)\s*(MS|S|M|H|D)/g;
  let match;
  let totalMs = 0;
  let found = false;

  while ((match = regex.exec(cleanStr)) !== null) {
    found = true;
    const value = parseFloat(match[1] || '0');
    const unit = match[2];

    switch (unit) {
      case 'MS':
        totalMs += value;
        break;
      case 'S':
        totalMs += value * 1000;
        break;
      case 'M':
        totalMs += value * 60 * 1000;
        break;
      case 'H':
        totalMs += value * 60 * 60 * 1000;
        break;
      case 'D':
        totalMs += value * 24 * 60 * 60 * 1000;
        break;
    }
  }

  if (!found) {
    return null; // Invalid format
  }

  return Math.floor(totalMs);
}

export function formatTime(ms: number): string {
  if (ms === 0) return '0ms';
  let remaining = ms;
  let result = '';

  const hours = Math.floor(remaining / (60 * 60 * 1000));
  if (hours > 0) {
    result += `${hours}h`;
    remaining %= 60 * 60 * 1000;
  }

  const minutes = Math.floor(remaining / (60 * 1000));
  if (minutes > 0) {
    result += `${minutes}m`;
    remaining %= 60 * 1000;
  }

  const seconds = Math.floor(remaining / 1000);
  if (seconds > 0) {
    result += `${seconds}s`;
    remaining %= 1000;
  }

  if (remaining > 0 || result === '') {
    result += `${remaining}ms`;
  }

  return result;
}
